'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentState = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_PATHS = {
  AGENT_STATE: ['agentState']
};

var getAgentState = exports.getAgentState = (0, _getIn2.default)(KEY_PATHS.AGENT_STATE);